import "./Dashboard.css";

function Dashboard() {
  return (
    <div className="main dashboard-main">
      {/* LEFT IMAGE */}
      <div className="left dashboard-left">
        <img src={require("../assets/dashboard.png")} alt="dashboard" />
        <a href="https://olocker.in/partners/public/login" className="emi-btn">
          Click to View EMI
        </a>
      </div>

      {/* R<img src={require("../assets/dashboard2.png")} alt="dashboard" />IGHT CONTENT */}
      <div className="right dashboard-right">
        <img src={require("../assets/dashboard2.png")} alt="dashboard" />
      </div>
    </div>
  );
}

export default Dashboard;
